<!--
  Die Safes von KF — Passwort-Safe und Akten-Safe als Kombiprodukt.

  Bis zum 01.09.2026 hieß dieses Produkt „Vertraut" und wurde auf einer
  eigenen Seite (meinvertraut.de) verkauft; dieser Abschnitt war nur ein
  Verweis dorthin. Seit der Rückführung auf die eine Marke steht das Produkt
  hier — die Preise bleiben aber im Preis- und Leistungsverzeichnis
  (/entgelte), damit es weiterhin nur EINE Preisdarstellung gibt.
-->
<section id="safes" class="abschnitt tb-gradient">
  <div class="breite">
    <div class="zwei-spalten">
      <div>
        <span class="hero-vorzeile">Unser Angebot für Zugänge &amp; Unterlagen</span>
        <h2 class="hell-titel">Passwörter und Dokumente? Die Safes von KF.</h2>
        <p class="hero-lead">
          Alle Zugänge und wichtigen Unterlagen an einem sicheren Ort — auf Servern in
          Deutschland, persönlich eingerichtet. Für Vereine, Betriebe und auf Anfrage
          auch privat.
        </p>
        <ul class="checkliste hell-liste">
          <li>KF Passwort-Safe und durchsuchbarer KF Akten-Safe als Komplettpaket</li>
          <li>Einrichtung, Einweisung und Produkt-Support inklusive</li>
          <li>Vereine 49&nbsp;€/Monat · Betriebe 69&nbsp;€/Monat · privat auf Anfrage</li>
        </ul>
      </div>
      <div class="karte safe-karte">
        <div class="wortmarke">KF<span class="punkt">.</span></div>
        <p class="leise">
          Verschlüsselt auf Ihrem Gerät — wir sehen Ihre Passwörter und Unterlagen nicht.
          Leistungen und Preise im Einzelnen:
        </p>
        <a class="tb-btn-primary" href="/entgelte">Preise und Leistungen →</a>
      </div>
    </div>
  </div>
</section>

<style>
  .hell-titel {
    color: #fff;
  }

  .hell-liste li {
    color: var(--tb-light-100);
  }

  .safe-karte {
    text-align: center;
    align-self: center;
    display: grid;
    gap: 1rem;
    justify-items: center;
    background: #fff;
  }

  .safe-karte .wortmarke {
    font-size: 1.6rem;
    font-weight: 800;
    letter-spacing: -0.02em;
    color: var(--tb-navy-900);
  }

  .safe-karte .punkt {
    color: var(--tb-amber-500);
  }
</style>
